import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Link, AppBar, Toolbar, IconButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import MenuIcon from '@mui/icons-material/Menu'
import Sidebar from './Sidebar'
import logo from '../../images/logo_PTG_retina.png'

const DRAWER_WIDTH = 260

function PageLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false)
  const theme = useTheme()

  // Skip link styles - visually hidden but accessible to screen readers
  const skipLinkStyles = {
    position: 'absolute',
    left: '-9999px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    zIndex: 9999,
    '&:focus': {
      position: 'fixed',
      top: 8,
      left: 8,
      width: 'auto',
      height: 'auto',
      padding: '12px 24px',
      backgroundColor: 'primary.main',
      color: theme.palette.primary.contrastText,
      textDecoration: 'none',
      borderRadius: 2,
      boxShadow: 4,
      fontWeight: 600
    }
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Skip Links for Accessibility */}
      <Link
        href="#main-content"
        sx={skipLinkStyles}
        tabIndex={0}
      >
        Skip to main content
      </Link>
      <Link
        href="#navigation"
        sx={skipLinkStyles}
        tabIndex={0}
      >
        Skip to navigation
      </Link>

      {/* Mobile AppBar with Hamburger Menu */}
      <AppBar
        position="fixed"
        sx={{
          display: { xs: 'flex', md: 'none' },
          bgcolor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
          boxShadow: 'none'
        }}
      >
        <Toolbar sx={{ minHeight: 56 }}>
          <IconButton
            color="inherit"
            aria-label="open navigation menu"
            edge="start"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component="img"
            src={logo}
            alt="Powertron"
            sx={{ height: 32, ml: 1 }}
          />
        </Toolbar>
      </AppBar>

      <Sidebar mobileOpen={mobileOpen} onClose={handleDrawerToggle} />

      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          bgcolor: 'background.default',
          p: { xs: 1.5, sm: 2, md: 3 },
          pt: { xs: 8, sm: 9, md: 3 },
          '&:focus': {
            outline: 'none'
          }
        }}
      >
        {/* Render nested routes via Outlet, plus any direct children */}
        {children}
        <Outlet />
      </Box>
    </Box>
  )
}

export default PageLayout
